module.exports = __webpack_public_path__ + "static/media/bs.7caacd6f.svg";